import { cn } from "@/lib/tailwind";
import { PropsWithChildren } from "react";

const Divider = ({
  children,
  lineClassName,
  containerClassName,
  position = "horizontal",
}: PropsWithChildren<{
  lineClassName?: string;
  containerClassName?: string;
  position?: "vertical" | "horizontal";
}>) => {
  return (
    <span
      className={cn("flex items-center", position === "vertical" && "flex-col", containerClassName)}
    >
      <span
        className={cn(
          "flex-1 bg-[#c4c4c4]",
          position === "horizontal" ? "h-px" : "h-full w-px",
          lineClassName,
        )}
      />
      {children}
      <span
        className={cn(
          "flex-1 bg-[#c4c4c4]",
          position === "horizontal" ? "h-px" : "h-full w-px",
          lineClassName,
        )}
      />
    </span>
  );
};

export default Divider;
